export enum MetadataType {
  Logo = -10,
  ContractType = -9,
  SumUpToken = 1
}
